import Axios from "../config/config";

//video

export const ADD_VIDEO_VIEW = async (body) => {
    try {
        const response = await Axios.post('add-video-view/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
export const EDIT_VIDEO_VIEW = async (body) => {
    try {
        const response = await Axios.post('edit-video-view/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const LIST_VIDEO = async (body) => {
    try {
        const response = await Axios.post('list-videos/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const DELETE_VIDEO = async (body) => {
    try {
        const response = await Axios.post('delete-video/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const GET_AWS_SIGN_UPLOAD_VIDEO = async (body) => {
    try {
        const response = await Axios.post('get-aws-sign-upload-video/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};